import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { response as res } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  base: string = environment.baseUrl;

  api: string = environment.baseUrl + "hcp/patient";

  env: string = environment.baseUrl + "Relative";

  constructor(private http: HttpClient) { }

  getPatientById = (id: number) => this.http.get<res>(this.api + `/${id}`)

  // Relative

  getRelativeById = (id: number) => this.http.get<res>(this.env + "/" + id)

  deleteRelative = (id: number) => this.http.delete<res>(this.env + "/" + id)

  getRelatives = () => this.http.get<res>(this.env);

  postRelative = (payload: FormData) => this.http.post<res>(this.env, payload)

  patchRelative = (payload: FormData) => this.http.patch<res>(this.env, payload)

  // Account update

  patchAccount = (payload: FormData) => this.http.patch<res>(this.base + `Account/update`, payload);

  refreshToken = (payload: FormData) => this.http.post<res>(this.base + `Account/refreshToken`, payload);

  // Assignment

  getAssignments = (req: String) => this.http.get<res>(this.base + "Assignment?" + req);

  // MedicalHistory

  getMedicalNotesHistory = (req: string) => this.http.get<any>(this.base + "hcp/patientManagement/medical-note-report?" + req)

  getMedicalFilesHistory = (req: string) => this.http.get<any>(this.base + "hcp/patient/all-medical-report" + req)

  getMedicalNotesReportBy = (id: number) => this.http.get<any>(this.base + "hcp/patientManagement/GetMedicalNotesReportById?Id=" + id)

  // VisitDetailsForNoteDetails
  getVisitForPatientById = (id: number) => this.http.get<any>(this.base + "Visit/" + id);

}
